<div class="integer-filter-input">
  @if ((selectionType$$ | async) === 'single') {
    <glxy-form-field class="filter-integer-selector">
      <input
        matInput
        type="number"
        inputmode="numeric"
        pattern="[0-9-]*"
        digitOnly
        placeholder="{{ 'GALAXY.FILTER.CHIP.VALUE_PLACEHOLDER' | translate }}"
        [formControl]="valueControl"
      />
    </glxy-form-field>
  } @else {
    <glxy-form-field class="filter-integer-range-selector">
      <input
        matInput
        type="number"
        inputmode="numeric"
        pattern="[0-9-]*"
        digitOnly
        placeholder="{{ 'GALAXY.FILTER.CHIP.START_VALUE_PLACEHOLDER' | translate }}"
        [formControl]="valueControl"
      />
    </glxy-form-field>
    <span class="range-splitter">–</span>
    <glxy-form-field class="filter-integer-range-selector">
      <input
        matInput
        type="number"
        inputmode="numeric"
        pattern="[0-9-]*"
        digitOnly
        placeholder="{{ 'GALAXY.FILTER.CHIP.END_VALUE_PLACEHOLDER' | translate }}"
        [formControl]="endValueControl"
      />
    </glxy-form-field>
  }
</div>
